import { QA } from "../type";

export const QAs: QA[] = [
  {
    qu: "What is Codeblaze?",
    an: "Codeblaze is an AI-driven platform that automates the entire coding process, enabling users to create full-stack applications effortlessly. With features like text prompts, voice-to-code, and image-based code generation, it simplifies development from start to finish.",
  },
  {
    qu: "How does Codeblaze work?",
    an: "Codeblaze uses advanced AI to process your input—whether it’s a text prompt, voice command, or uploaded image—and generates clean, functional code. It handles everything from analysis to deployment-ready solutions, minimizing user intervention.",
  },
  {
    qu: "Why is Codeblaze 100 times faster if it’s only a 1:10 ratio?",
    an: "The 1:10 ratio reflects the time saved on individual tasks (1 hour for Codeblaze versus 10 hours for a senior developer). However, Codeblaze operates continuously and autonomously, handling multiple projects and tasks simultaneously without downtime. This scalability enables it to achieve results equivalent to 100 times the output of traditional development over time.",
  },
  {
    qu: "What types of projects can I build with Codeblaze?",
    an: "Codeblaze supports a wide variety of projects, including web apps, mobile apps, and cross-platform solutions. Whether you’re creating a simple tool or a complex enterprise application, Codeblaze adapts to fit your needs.",
  },
  {
    qu: "How many coding languages does Codeblaze support?",
    an: "Codeblaze supports over 50 programming languages, providing flexibility for users to work with their preferred technologies or frameworks.",
  },
  {
    qu: "How does Codeblaze save time and reduce costs?",
    an: "By automating the coding process, Codeblaze completes tasks 90% faster than traditional development. This reduces time spent on repetitive tasks, lowers operational costs, and allows teams to focus on strategic priorities.",
  },
  {
    qu: "Is Codeblaze suitable for non-developers?",
    an: "Yes! Codeblaze’s intuitive interface makes it accessible to non-developers, enabling them to create fully functional applications with ease. Its AI simplifies technical complexities, making development straightforward for everyone.",
  },
  {
    qu: "Can I update or scale my project after deployment?",
    an: "Absolutely. Codeblaze allows users to update or scale their projects by providing additional prompts. The AI quickly generates updates or enhancements while maintaining the integrity of the existing application.",
  },
  {
    qu: "How does Codeblaze ensure code quality?",
    an: "Codeblaze’s AI is designed to generate clean, optimized, and secure code. It incorporates best practices across multiple languages and frameworks to deliver reliable and production-ready solutions.",
  },
  {
    qu: "How secure is Codeblaze?",
    an: "Codeblaze prioritizes security with robust measures to protect your data and projects. The platform follows industry standards to ensure that your applications are safe and dependable throughout the development lifecycle.",
  },
];
